<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-26 13:33:52
 * @Description: file content
 rule rank prize
 规则、排行、奖品
 -->
<template>
  <div :class="['mymodal', `modal-${$setting.name}`, { animate: value && message.animate }]" :style="{ backgroundColor: message.bgColor }" v-show="value">
    <div class="info">
      <!-- <img class="form-title" src="http://assets.rurushishi.com/activies/hhjx-purchase/form1.png" /> -->
      <img class="modalTitle" :src="configInfo.popupStyleImg" />
      <div class="msg-info" :style="infoStyle">
          <div class="msgTitle">领取成功！</div>
          <img class="qrCode" :src="wxWorkImg" />
          <div class="tip" v-html="text">
            {{configInfo.wxWorkTip}}
          </div>
      </div>
      <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      message: "",
      configInfo: {},
      text: "",
      wxWorkImg:''
    };
  },
  watch: {
    tip: {
      handler(val) {
      },
      deep: true,
    },
  },
  computed: {
    infoStyle() {
      if (this.$setting.name == "blindbox") {
        let  borderColor=this.$configInfo.buttonBackgroundColour
        if([3,4,5].includes(parseInt(this.$configInfo.uiExt.uiExtTemplate))){
          borderColor=this.$configInfo.backgroundColour
        }
        return {
          backgroundColor: this.$configInfo.popupBackgroundColour,
          borderColor: borderColor,
          "border-radius": 0,
        };
      }
      return {
        backgroundColor: this.$configInfo.popupBackgroundColour,
      };
    },
  },
  mounted() {
    this.configInfo =this.$configInfo 
    
    let wxWorkTip=this.configInfo.wxWorkTip||''
          this.text=wxWorkTip.replace(/\n/g, '<br/>')
    if(this.configInfo.bizType==4||this.configInfo.bizType==3){
      this.wxWorkImg =this.$util.cookie.get('receivePrizePage')
    }else{
      this.wxWorkImg =this.$util.cookie.get('wxWorkImg')
    }
  },
  methods: {
    clickClose() {
      this.value = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  &.modal-blindbox {
    .msg-info {
      border-style:solid;
      border-width:12px 12px 18px;
      position:relative;
      &::after {
        content:'';
        position:absolute;
        bottom:-7px;
        left:0;
        right:0;
        height:8px;
        background: url(https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/circle-line.png?v=20220124) no-repeat center;
        background-size:100% auto;
      }
    }
  }

  .info {
    position: relative;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .modalTitle {
      position: relative;
      width: 300px;
      z-index: 1;
    }

    .msg-info {
      position: relative;
      z-index: 0;
      margin-top: -1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 0px 0px 16px 16px;
      width: 100%;
      box-sizing: border-box;
      padding-bottom: 24px;
        padding-top: 16px;

      .msgTitle {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #262626;
      }

      .qrCode {
        width: 160px;
        margin-top: 12px;
      }

      .code {
        font-size: 18px;
        line-height: 24px;
        color: #000000;
        font-weight: 500;
        padding:0 20px;
        word-wrap: break-word;
        word-break: break-all;
      }

      .tip {
        width: 240px;
        margin-top: 10px;
        font-size: 12px;
        line-height: 20px;
        color: #595959;
        text-align: center;
      }

      .submit {
        margin-top: 12px;
        width: 220px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        border-radius: 24px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      }
    }

    .close {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1002;
      margin-top: 28px;
    }
  }
}
</style>
